// Secteurs & métiers AYA PRO (maquette Réf 4 — « Quelle activité souhaitez-vous inscrire ? »).
export const SECTORS = [
  { id: "commerce", label: "Commerçant & Boutique", icon: "🛍️", bg: "#E8F8EF", metiers: [
    { id: "boutique-alimentation", label: "Boutique & Alimentation", sub: "Vivres, boissons, produits du quotidien", icon: "🧺" },
    { id: "marche-vivrier", label: "Marché & Vivrier", sub: "Fruits, légumes, cocos, produits frais", icon: "🥥" },
    { id: "pret-a-porter", label: "Prêt-à-porter & Mode", sub: "Vêtements, chaussures, accessoires", icon: "👗" },
    { id: "cosmetiques", label: "Cosmétiques & Beauté", sub: "Soins, maquillage, produits capillaires", icon: "💄" },
    { id: "electronique", label: "Électronique & Téléphonie", sub: "Téléphones, accessoires, réparation", icon: "📱" },
    { id: "autre-commerce", label: "Autre commerce", sub: "Indiquez votre activité", icon: "🏪" },
  ]},
  { id: "avocats", label: "Cabinet d'avocats", icon: "⚖️", bg: "#EAF2FB", metiers: [
    { id: "avocat-affaires", label: "Avocat d'affaires", sub: "Sociétés, contrats, fiscalité", icon: "💼" },
    { id: "avocat-famille", label: "Avocat droit de la famille", sub: "Divorce, succession, filiation", icon: "👨‍👩‍👧" },
    { id: "avocat-penal", label: "Avocat pénaliste", sub: "Défense pénale", icon: "🏛️" },
    { id: "autre-avocat", label: "Autre spécialité", sub: "Indiquez votre spécialité", icon: "📜" },
  ]},
  { id: "notaires", label: "Cabinet de notaires", icon: "📜", bg: "#FDF3E3", metiers: [
    { id: "notaire", label: "Notaire", sub: "Actes, successions, immobilier", icon: "🖋️" },
    { id: "clerc", label: "Clerc de notaire", sub: "Assistance notariale", icon: "📂" },
  ]},
  { id: "sante", label: "Professionnel de santé", icon: "🩺", bg: "#E9F7FB", metiers: [
    { id: "medecin", label: "Médecin généraliste", sub: "Consultations générales", icon: "👨‍⚕️" },
    { id: "pharmacien", label: "Pharmacien", sub: "Officine, parapharmacie", icon: "💊" },
    { id: "infirmier", label: "Infirmier / Sage-femme", sub: "Soins à domicile, suivi", icon: "💉" },
    { id: "dentiste", label: "Dentiste", sub: "Soins dentaires", icon: "🦷" },
    { id: "autre-sante", label: "Autre métier de santé", sub: "Indiquez votre métier", icon: "🏥" },
  ]},
  { id: "restaurant", label: "Restaurant & Traiteur", icon: "🍽️", bg: "#FBEFEA", metiers: [
    { id: "maquis", label: "Maquis & Restaurant", sub: "Cuisine ivoirienne, grillades", icon: "🍗" },
    { id: "traiteur", label: "Traiteur", sub: "Événements, mariages, buffets", icon: "🥘" },
    { id: "patisserie", label: "Pâtisserie & Boulangerie", sub: "Pains, gâteaux, viennoiseries", icon: "🥐" },
    { id: "street-food", label: "Street food", sub: "Garba, alloco, brochettes", icon: "🌽" },
  ]},
  { id: "transport", label: "Transport", icon: "🚕", bg: "#FFF6E0", metiers: [
    { id: "taxi", label: "Taxi", sub: "Courses urbaines", icon: "🚖" },
    { id: "car-interurbain", label: "Car interurbain", sub: "Liaisons entre villes", icon: "🚌" },
    { id: "chauffeur-prive", label: "Chauffeur privé / VTC", sub: "Courses avec chauffeur", icon: "🚘" },
    { id: "livraison-moto", label: "Livraison moto", sub: "Colis et repas", icon: "🏍️" },
  ]},
  { id: "immobilier", label: "Immobilier", icon: "🏠", bg: "#FBEAF0", metiers: [
    { id: "agent-immo", label: "Agent immobilier", sub: "Vente, location, gestion", icon: "🔑" },
    { id: "promoteur", label: "Promoteur", sub: "Programmes neufs", icon: "🏗️" },
    { id: "gestionnaire", label: "Gestionnaire de biens", sub: "Gestion locative", icon: "🗂️" },
  ]},
  { id: "artisan-btp", label: "Artisan & BTP", icon: "🛠️", bg: "#FDEFE4", metiers: [
    { id: "plombier", label: "Plombier", sub: "Installation, dépannage, chauffe-eau", icon: "💧" },
    { id: "electricien", label: "Électricien", sub: "Installation, dépannage, rénovation", icon: "⚡" },
    { id: "peintre", label: "Peintre", sub: "Peinture, décoration, façade", icon: "🖌️" },
    { id: "macon", label: "Maçon", sub: "Construction, rénovation, béton", icon: "🧱" },
    { id: "climatisation", label: "Climatisation", sub: "Installation, entretien, réparation", icon: "❄️" },
    { id: "menuisier", label: "Menuisier", sub: "Bois, aluminium, menuiserie", icon: "🚪" },
    { id: "couvreur", label: "Couvreur", sub: "Toiture, étanchéité", icon: "👷" },
    { id: "autre-metier", label: "Autre métier", sub: "Indiquez votre activité", icon: "🧰" },
  ]},
  { id: "numerique", label: "Services numériques", icon: "💻", bg: "#EDF0FB", metiers: [
    { id: "developpeur", label: "Développeur / Agence web", sub: "Sites, applications", icon: "🖥️" },
    { id: "graphiste", label: "Graphiste / Designer", sub: "Logos, supports visuels", icon: "🎨" },
    { id: "community-manager", label: "Community manager", sub: "Réseaux sociaux", icon: "📣" },
    { id: "maintenance-info", label: "Maintenance informatique", sub: "Dépannage, réseaux", icon: "🔧" },
  ]},
  { id: "education", label: "Éducation & Formation", icon: "🎓", bg: "#FDF6E0", metiers: [
    { id: "repetiteur", label: "Répétiteur / Cours à domicile", sub: "Soutien scolaire", icon: "📚" },
    { id: "centre-formation", label: "Centre de formation", sub: "Formations professionnelles", icon: "🏫" },
    { id: "ecole-privee", label: "École privée", sub: "Maternelle au lycée", icon: "🎒" },
    { id: "auto-ecole", label: "Auto-école", sub: "Permis de conduire", icon: "🚗" },
  ]},
];

export const findSector = (id) => SECTORS.find((s) => s.id === id) || null;
export const findMetier = (sectorId, metierId) => (findSector(sectorId)?.metiers || []).find((m) => m.id === metierId) || null;
